module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gal_layer_off-ecccf7e882d2f56370817581bd1e5a89.jpg";